import { styled } from "@mui/system";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  container: {
    backgroundColor: "rgba(0,0,0,.3)"
  },
  paper: {
    width: "600px",
    borderRadius: "8px",
    boxShadow: "10px 10px 18px 0 rgba(0, 0, 0, 0.2)",
    backgroundColor: "#ffffff",
    "@media (max-width: 420px)": {
      overflow: "hidden",
      margin: "0 15px"
    }
  }
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  textAlign: "center",
  padding: "15px 40px 0px 40px",
  "& > h2": {
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: 1.33,
    letterSpacing: "normal"
  }
}));

export const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
  fontSize: "30px",
  border: "3px solid red",
  borderRadius: "50px",
  padding: "5px"
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: "5px 30px",
  fontSize: "15px"
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  alignItems: "center",
  padding: "15px",
  justifyContent: "center"
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  width: "100%",
  height: "40px",
  borderRadius: "21px",
  textTransform: "capitalize",
  fontSize: "16px",
  fontWeight: 600,
  letterSpacing: "normal",
  "@media (max-width: 372px)": {
    width: "100%",
    marginLeft: 0
  }
}));

export const StyledAgentButton = styled(Button)(({ theme }) => ({
  width: "200px",
  height: "40px",
  borderRadius: "21px",
  textTransform: "capitalize",
  fontSize: "16px",
  fontWeight: 600,
  letterSpacing: "normal",
  "@media (max-width: 372px)": {
    width: "100%",
    marginLeft: 0
  }
}));

export const StyledGrid = styled(Grid)(({ theme }) => ({
  padding: "5px",
  width: "100%",
  textAlign: "center"
}));

export const StyledDivider = styled("div")(({ theme }) => ({
  width: "200px",
  marginLeft: "0 !important",
  textAlign: "center"
}));
